import { createStore } from "effector";
import { IResetPasswordStore } from "./types";
import { resetPasswordFx } from "./effects";
import {
	INITIAL_RESET_PASSWORD_STORE,
	RESET_PASSWORD_COOLDOWN
} from "./consts";
import {
	resetErrors,
	setInputValue,
	setResetPasswordsStore,
	setSent,
} from "./events";


// Основной стор для хранения данных поля ввода почты, отправлен ли запрос
// и времени окончания таймера повторной отправки
export const $resetPasswordStore = createStore<IResetPasswordStore>(INITIAL_RESET_PASSWORD_STORE)
	.on(setInputValue, (state, { key, value }) => {
		return {
			...state,
			[key]: {
				...state[key],
				value: value,
			}
		}
	})
	.on(setSent, (state, value) => {
		return {
			...state,
			isRequestSent: value,
    		cooldownEnd: value ? Date.now() + RESET_PASSWORD_COOLDOWN * 1000 : 0
		}
	})
	.on(setResetPasswordsStore, (_, data) => data)
	.on(resetErrors, (state, key) => {
		return {
			...state,
			[key]: {
				...state[key],
				isValid: true,
				errorMessage: '',
			},
		}
	})


// Статус запроса на отправку ссылки для изменения пароля
export const isPending = resetPasswordFx.pending;	


// Отсчёт секунд для повторной отправки
export const $secondsLeft = createStore(0);
